import React from "react";
import { ModeRendererProps } from "./types";

export function JansenWindMode({ brand }: ModeRendererProps) {
  return (
    <g>
      {/* Sky gradient simulation */}
      <rect x="0" y="0" width="794" height="400" fill={brand.deep} />
      <rect x="0" y="400" width="794" height="723" fill={brand.deep} opacity="0.7" />
      
      {/* Wind vortex */}
      {Array.from({ length: 30 }).map((_, i) => {
        const angle = i * 12;
        const radius = 100 + i * 8;
        const cx = 397 + radius * Math.cos((angle * Math.PI) / 180);
        const cy = 300 + radius * Math.sin((angle * Math.PI) / 180);
        return (
          <circle
            key={i}
            cx={cx}
            cy={cy}
            r="3"
            fill={i % 3 === 0 ? brand.aqua : i % 3 === 1 ? brand.white : brand.violet}
            opacity={0.7 - i * 0.02}
          />
        );
      })}
      
      {/* Wind flow lines */}
      {Array.from({ length: 15 }).map((_, i) => (
        <path
          key={i}
          d={`M0 ${200 + i * 40} Q ${200 + i * 10} ${180 + i * 40} ${397} ${220 + i * 40} T 794 ${200 + i * 40}`}
          stroke={brand.aqua}
          strokeWidth="1.5"
          fill="none"
          opacity={0.3}
          strokeDasharray="10 5"
        />
      ))}
      
      {/* Strandbeest in wind */}
      <g transform="translate(397 700)">
        {/* Multiple sails catching wind */}
        {[-100, 0, 100].map((x, i) => (
          <g key={i} transform={`translate(${x} 0)`}>
            <polygon
              points={`0,-180 ${60 + i * 10},-60 ${-60 - i * 10},-60`}
              fill="url(#sail)"
              opacity={0.7}
              transform={`rotate(${(i - 1) * 5})`}
            />
            <line x1="0" y1="-180" x2="0" y2="0" stroke={brand.white} strokeWidth="3" />
          </g>
        ))}
        
        {/* Base platform */}
        <rect x="-200" y="0" width="400" height="20" fill={brand.white} opacity="0.2" />
        
        {/* Simplified legs */}
        {[-150, -75, 0, 75, 150].map((x, i) => (
          <g key={i} transform={`translate(${x} 10)`}>
            <line x1="0" y1="0" x2="20" y2="60" stroke={brand.white} strokeWidth="2" />
            <line x1="20" y1="60" x2="-20" y2="80" stroke={brand.white} strokeWidth="2" />
            <circle cx="-20" cy="80" r="4" fill={brand.amber} />
          </g>
        ))}
      </g>
      
      {/* Blowing particles */}
      {Array.from({ length: 40 }).map((_, i) => (
        <circle
          key={i}
          cx={50 + (i * 37) % 794}
          cy={100 + (i * 53) % 600}
          r={1 + (i % 3)}
          fill={brand.white}
          opacity={0.4}
        />
      ))}
    </g>
  );
}
